import { StThreeStepItemVar2 } from './ThreeStepInformation.style';
import { IThreeStepItemProps } from './ThreeStepInformation.types';
import ThreeStepImage from './ThreeStepImage';
import UiText from '../../components/shared/Typography/UiText';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import useApplyV2Theme from '../../lib/hooks/useApplyV2Theme';
import { Box, Typography } from '@mui/material';

const ThreeStepItemVar2: React.FC<IThreeStepItemProps> = (props) => {
  const { isToapplyV2Theme } = useApplyV2Theme();
  return (
    <StThreeStepItemVar2>
      <ThreeStepImage field={props.fields?.icon} />
      {isToapplyV2Theme ? (
        <>
          <UiText bold styles={{ fontSize: '32px' }}>
            {props.fields?.stepNumber?.value}
          </UiText>
          <RichText field={props.fields?.description} />
        </>
      ) : (
        <>
          <Typography variant="h3">
            <Text field={props.fields?.stepNumber} />
          </Typography>
          <Box>
            <RichText field={props.fields?.description} />
          </Box>
        </>
      )}
    </StThreeStepItemVar2>
  );
};

export default ThreeStepItemVar2;
